export const SEGMENTS = [
  {
    slug: "residential",
    name: "Residential",
    h1: "Residential Solutions",
    metaTitle: "Residential Security & Technology Solutions | SafeHome Security Solutions",
    metaDescription:
      "Home security cameras, video doorbells, smart locks, alarms, WiFi, home theatre and lighting for houses, cottages and condos. Free quotes.",
    intro:
      "Your home should feel safe, connected and easy to live in. We design and install systems for houses, cottages, condos and rental properties — from a single video doorbell to a full camera, alarm, WiFi and theatre setup, all installed by one tidy, professional team.",
    services: [
      "security-camera-installation",
      "video-doorbell-intercom",
      "smart-locks",
      "alarm-ulc-monitoring",
      "wifi-access-points",
      "audio-visual-home-theatre",
      "tv-mounting",
      "holiday-permanent-lighting",
    ],
  },
  {
    slug: "commercial",
    name: "Commercial",
    h1: "Commercial Solutions",
    metaTitle: "Commercial Security & Technology Solutions | SafeHome Security Solutions",
    metaDescription:
      "Commercial security cameras, access control, alarms, structured cabling and business WiFi for offices, buildings and professional spaces. Free quotes.",
    intro:
      "Businesses need systems that work every day and scale as they grow. We install commercial-grade cameras, access control, alarms, cabling and WiFi for offices, professional suites and multi-unit buildings — documented, labelled and supported after the install.",
    services: [
      "access-control",
      "security-camera-installation",
      "alarm-ulc-monitoring",
      "structured-cabling",
      "wifi-access-points",
    ],
  },
  {
    slug: "retail",
    name: "Retail",
    h1: "Retail Solutions",
    metaTitle: "Retail Security & Technology Solutions | SafeHome Security Solutions",
    metaDescription:
      "Security cameras, access control, alarms, audio/visual and lighting for stores, restaurants and customer-facing spaces. Free quotes.",
    intro:
      "Retail spaces live on presentation and loss prevention. We install camera coverage for tills and aisles, staff access control, monitored alarms, background audio, displays and storefront lighting that keeps your space welcoming after dark.",
    services: [
      "security-camera-installation",
      "access-control",
      "alarm-ulc-monitoring",
      "audio-visual-home-theatre",
      "holiday-permanent-lighting",
    ],
  },
  {
    slug: "industrial",
    name: "Industrial",
    h1: "Industrial Solutions",
    metaTitle: "Industrial Security & Technology Solutions | SafeHome Security Solutions",
    metaDescription:
      "Security cameras, access control, structured cabling and warehouse WiFi for industrial and commercial facilities. Free quotes.",
    intro:
      "Warehouses, shops and industrial facilities need coverage over big spaces and tough conditions. We install long-range camera systems, door and gate access control, heavy-duty cabling and wide-area WiFi that keep operations visible and connected.",
    services: [
      "security-camera-installation",
      "access-control",
      "structured-cabling",
      "wifi-access-points",
    ],
  },
];
